var map = {
	"./webspecial_event_bar_cn.webm": 9250,
	"./webspecial_event_bar_de.webm": 7428,
	"./webspecial_event_bar_en.webm": 4976,
	"./webspecial_event_bar_ja.webm": 6078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7806;